import { Record, List } from 'immutable';

const defaultValues = {
  id: null,
  textKey: null,
  typeId: null,
  typeItemIdParent: 0,
  typeItemName: '',
  abbreviation: '',
  iconName: null,
  archived: false,
};

export const count = ['ct', 'ea'];

export const imperialWeights = ['oz','lb','ea','g','kg'];

export const imperialVolumes = ['tsp', 'tbl', 'cup', 'pt', 'qt', 'gal','ea','foz','l','ml'];

export const metricWeights = ['oz','lb','ea','g','kg'];

export const metricVolumes = ['tsp', 'tbl', 'cup', 'pt', 'qt', 'gal','ea','foz','l','ml'];

export const UOM_KEY_EACH = 'ea';

export const DEFAULT_CUSTOM_UOM = 'units';

export const UOM_KEY_UNKNOWN = 'unknown';

export const UOM_KEY_UNSPECIFIED = 'unspecified';

export default class TypeItem extends Record(defaultValues, TypeItem) {
  constructor(values) {
    super({
      ...values,
    });
  }

  static getTypeItemsByType(typeItems, type) {
    return typeItems.filter(item => {
      return item.get('typeId') === type;
    });
  }

  static getActiveTypeItemsByType(typeItems, type) {
    return typeItems.filter((item) => {
      return item.get('typeId') === type && !item.get('archived');
    });
  }

  static getTypeItemsByTypeItemIdParent(typeItems, typeItemIdParent) {
    return typeItems.filter(item => {
      return item.get('typeItemIdParent') === typeItemIdParent;
    });
  }

  static findTypeItemById(typeItems, id) {
    return typeItems.find(type => {
      return type.get('id') == id ? type : undefined;
    });
  }

  static findTypeItemIndexById(typeItems, id) {
    return typeItems.findIndex(type => {
      return type.get('id') === id ? type : undefined;
    });
  }

  static mergeTypeItems(stateList, actionList) {
    let mergedList = stateList;
    actionList.forEach((item) => {
      const id = item.get('id');
      const isInList = TypeItem.findTypeItemById(stateList, id);
      if (!isInList) {
        mergedList = mergedList.push(item);
      } else {
        let stateIndex = TypeItem.findTypeItemIndexById(mergedList, id);
        //mergedList = mergedList.delete(stateIndex);
        //mergedList = mergedList.push(item);
        mergedList = mergedList.set(stateIndex, item);
      }
    });
    return mergedList;
  }

  static sortTypeItemsByName(typeItems) {
    return typeItems.sort((itemOne, itemTwo) => {
      return itemOne.get('typeItemName').localeCompare(itemTwo.get('typeItemName'));
    });
  }

  static isImperialWeight(value) {
    return imperialWeights.includes(value.toLowerCase());
  }

  static isImperialVolume(value) {
    return imperialVolumes.includes(value.toLowerCase());
  }

  static isMetricWeight(value) {
    return metricWeights.includes(value.toLowerCase());
  }

  static isMetricVolume(value) {
    return metricVolumes.includes(value.toLowerCase());
  }

  static isCount(value) {
    return count.includes(value.toLowerCase());
  }

  static filterImperialWeights(typeItems) {
    return typeItems.filter((type) => {
      return TypeItem.isImperialWeight(type.get('textKey')) ? type : undefined;
    });
  }

  static filterImperialVolumes(typeItems) {
    return typeItems.filter((type) => {
      return TypeItem.isImperialVolume(type.get('textKey')) ? type : undefined;
    });
  }

  static filterMetricWeights(typeItems) {
    return typeItems.filter((type) => {
      return TypeItem.isMetricWeight(type.get('textKey')) ? type : undefined;
    });
  }

  static filterByMetricVolumes(typeItems) {
    return typeItems.filter((type) => {
      return TypeItem.isMetricVolume(type.get('textKey')) ? type : undefined;
    });
  }

  static filterOutNapkinDispenser (typeItems) {
    return typeItems.filter((item) => {
      return item.get('textKey') !== 'napkin-dispenser';
    });
  }

  static filterOutOneType (typeItems, textKey) {
    return typeItems.filter((item) => {
      return item.get('textKey') !== textKey;
    });
  }

  static filterOutByTextKey (typeItems, textKey) {
    return typeItems.filter((item) => {
      return item.get('textKey') === textKey;
    });
  }

  static filterCount(typeItems) {
    return typeItems.filter((type) => {
      return TypeItem.isCount(type.get('textKey')) ? type : undefined;
    });
  }

  static getWeightUnitsByTextKey(typeItems, textKey) {
    // Count values only
    if (TypeItem.isCount(textKey)) {
      return TypeItem.filterCount(typeItems);
    }
    // Imperial plus count if imperial
    if (TypeItem.isImperialWeight(textKey)) {
      return TypeItem.filterImperialWeights(typeItems);
    }
    // Imperial volumes
    if (TypeItem.isImperialVolume(textKey)) {
      return TypeItem.filterImperialVolumes(typeItems);
    }
    // Metric plus count if metric
    if (TypeItem.isMetricWeight(textKey)) {
      return TypeItem.filterMetricWeights(typeItems);
    }
    if (TypeItem.isMetricVolume(textKey)) {
      return TypeItem.filterByMetricVolumes(typeItems);
    }
    return TypeItem.filterImperialWeights(typeItems);
  }

  static validUnitType(typeItems, costPerUnitKey, amountUnitKey) {
    const costPerUnits = TypeItem.getWeightUnitsByTextKey(typeItems, costPerUnitKey);
    return costPerUnits.filter((typeItem) => {
      return typeItem.get('textKey').length === amountUnitKey.length && typeItem.get('textKey').toLowerCase().includes(amountUnitKey.toLowerCase());
    });
  }

  static getDefaultWeightUnits(typeItems, textKey) {
    if (TypeItem.isImperialWeight(textKey) || TypeItem.isImperialVolume(textKey)) {
      return TypeItem.filterImperialWeights(typeItems).concat(
        TypeItem.filterImperialVolumes(typeItems)
      ).concat(TypeItem.filterCount(typeItems));
    }
    return TypeItem.filterMetricWeights(typeItems).concat(
      TypeItem.filterByMetricVolumes(typeItems)
    ).concat(TypeItem.filterCount(typeItems));
  }

  static filterOutUnitTypeByTextKey(typeItems, textKey) {
    if(TypeItem.isMetricWeight(textKey) || TypeItem.isImperialWeight(textKey)) {
      return typeItems.filter((type) => {
        return TypeItem.isMetricVolume(type.get('textKey'))
        || TypeItem.isImperialVolume(type.get('textKey')) ? type : undefined;
      });
    } else if (TypeItem.isMetricVolume(textKey) || TypeItem.isImperialVolume(textKey)) {
      return typeItems.filter((type) => {
        return TypeItem.isMetricWeight(type.get('textKey'))
        || TypeItem.isImperialWeight(type.get('textKey')) ? type : undefined;
      });
    }
    return typeItems;
  }

  static filterTypeItemByName(typeItems, keywords, ingredient) {
    let keywordsUpper = keywords.toUpperCase();
    return typeItems.filter((typeItem) => {
      //for custom UOM, typeItemName == Each
      if(typeItem.get('textKey') === UOM_KEY_EACH) {
        return ingredient.get('customUom') && ingredient.get('customUom').toUpperCase().includes(keywordsUpper)
        || DEFAULT_CUSTOM_UOM.toUpperCase().includes(keywordsUpper);
      }
      return typeItem.get('typeItemName') && typeItem.get('typeItemName').toUpperCase().includes(keywordsUpper)
      || typeItem.get('abbreviation') && typeItem.get('abbreviation').toUpperCase().includes(keywordsUpper);
    });
  }
}

export const TypeItems = (data, typeItemIdParent) => {
  let typeItems = new List();
  data.forEach((value) => {
    let typeItem = new TypeItem(value);
    if (typeItemIdParent) {
      typeItem = typeItem.set('typeItemIdParent', typeItemIdParent);
    }
    typeItems = typeItems.push(typeItem);
  });
  return typeItems;
};
